'use strict';

import { HTML_WIDTH, DESKTOP_BREAKPOINT, TABLET_BREAKPOINT, RELOAD_PAGE_ON_DESKTOP_BREAKPOINT } from './default-modules/default-variables';
import { getCookie, setCookie, eraseCookie } from './default-modules/default-cookies';
import { breakpoint_reload_page, comboBox_width } from './default-modules/default-utils';
import { add_filter_class } from './default-modules/default-filter';
import { frontpage_html } from './project-modules/project-frontpage';
import { footer } from './project-modules/project-footer';
import { login } from './project-modules/project-login';


$(document).ready(function($) {
    window.getCookie = getCookie;
  	window.setCookie = setCookie;
  	window.eraseCookie = eraseCookie;

    window.onresize = () => {
      if(RELOAD_PAGE_ON_DESKTOP_BREAKPOINT) {
        breakpoint_reload_page();
      }
      comboBox_width();
    }

/* Funktioner som ska anropas en gång */
  comboBox_width();

// desktop
  if (HTML_WIDTH > DESKTOP_BREAKPOINT) {

  }

// tablet och mobil
  if (HTML_WIDTH <= DESKTOP_BREAKPOINT) {

	}

// enbart mobil
  if (HTML_WIDTH < TABLET_BREAKPOINT) {

  }

/* Funktioner som ska anropas i loop */
  let interval = setInterval(()=> {
    add_filter_class();
  }, 200);

  footer();
  login();
})